export const tr = {
    'button-cancel': 'İptal',
    'button-submit': 'Uygula',
    'highest-bid': 'Dikkat! Teklif fazla yüksek olduğu için durduruldu'
};
